import { Component, Input } from '@angular/core';
import { Day, Vehicle2 } from '../../../../assets/models/iter.model';
import { getServiceNotes } from '../common/service-notes';
/**ToDo Documentazione */
@Component({
  selector: 'app-vehicles',
  styleUrls: ['./vehicles.component.scss'],
  templateUrl: './vehicles.component.html'
})
export class VehiclesComponent {
  @Input() public day: any;
  @Input() public version: any;
  @Input() public noImageUrl: any;
  @Input() public defaultImage: any;
  @Input() public replaceShowDescriptionButtonWithNotes: boolean = false;
  @Input() public serviceIcons: any;
  state: any = sessionStorage.getItem('state');

  public getFilteredNotes(notes: any): any[] {
    return getServiceNotes(notes, this.state);
  }

  constructor() {
  }

  public getVehicleImage(vehicle: Vehicle2): string {
    if (vehicle.image) {
      return vehicle.image;
    } else if (this.defaultImage || this.noImageUrl) {
      return this.defaultImage || this.noImageUrl;
    } else {
      return 'assets/custom/' + this.version + '/images/logo_tour_operator.png';
    }
  }

  public showLineAfter(day: Day): boolean {
    return day.flights.length > 0 || day.transfers.length > 0 ||
    day.hotels.length > 0 || day.optionals.length > 0 ||
    (day.flights.length > 0 && day.isLastDay);
  }

  formatData(data: { value?: string }[]): string {
    return data
        .map(item => item.value?.trim())
        .filter(Boolean)
        .map(value => `<p>${value}</p>`) 
        .join('');
  }

  hasVisibleComments(comments: any[]): boolean {
    return comments?.some(comment => comment.value) ?? false;
  }

  getIncludedEquipments(equipments: any[]): any[] {
    return equipments ? equipments.filter(equipment => equipment.purchasableOnline === true) : [];
  }

  getPayableEquipments(equipments: any[]): any[] {
    return equipments ? equipments.filter(equipment => equipment.purchasableOnline === false) : [];
  }
}
